import { render, staticRenderFns } from "./LocationAreas.vue?vue&type=template&id=5bcff6b4&scoped=true"
import script from "./LocationAreas.vue?vue&type=script&lang=js"
export * from "./LocationAreas.vue?vue&type=script&lang=js"
import style0 from "./LocationAreas.vue?vue&type=style&index=0&id=5bcff6b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcff6b4",
  null
  
)

export default component.exports